import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 600;
const LAPTOP_MD_BREAKPOINT = 1024;

interface ScreenSize {
  isMobile: boolean;
  isTabletOrSmaller: boolean;
  width: number;
}

export const useIsMobile = () => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    isMobile: window.innerWidth <= MOBILE_BREAKPOINT,
    isTabletOrSmaller: window.innerWidth < LAPTOP_MD_BREAKPOINT,
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        isMobile: width <= MOBILE_BREAKPOINT,
        isTabletOrSmaller: width < LAPTOP_MD_BREAKPOINT,
        width,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
